import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AppConstants } from 'src/app/common/app.constants';
import { MatDialog } from '@angular/material/dialog';
import { ShopinfoComponent } from '../../shopinfo.component';
import { ShopinfoModel } from '../../model/shopinfo.model';
@Component({
    selector: 'app-shop-summary',
    templateUrl: './shop-summary.component.html',
    styleUrls: ['./shop-summary.component.scss'],
    standalone: false
})
export class ShopSummaryComponent {
  @Input() shop: any;

  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();

  show: boolean = false;
  shops: any;
  displayedColumns: string[] = [ 'code','name'];
  constructor(
    private dialog: MatDialog
  ) {
    let sessionShop = sessionStorage.getItem(AppConstants.SESSION_VAR_SHOP);
    this.shops = (sessionShop !== null) ? JSON.parse(sessionShop) : [];
    console.log(this.shop);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['area']) {
    //   this.show = (this.area !== undefined);

    // }
  }

  /**
   * Closed the summary panel
   */
  close(): void {
    this.show = !this.show;
  }
  /**
   * Edit the current selected item
   */
  onEditAction() {
    this.onEdit.emit(this.shop);
  }
  /**
   * Delete the current item.
   */
  onDeleteAction() {
    this.onDelete.emit(this.shop);
  }

}
